import { useEffect, useState } from "react";
import { Container, Grid, Button, Text, Table, ScrollArea, Modal, Image,Flex } from "@mantine/core";
import MantinePagination from "../../components/mantine/pagination";
import TitleComponent from "../../components/common/title";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getDrawingBysite } from "../../store/actions";
import { PlaceholderUi, useCustomMediaQuery } from "../../helpers/common";
import { useStateContext } from "../../Contexts/ContextProvider";
import { drawingDetailColumns } from "../../helpers/columns";
import MantineCloseButton from "../../components/mantine/closeButton";
import MantineTextInput from "../../components/mantine/textinput";
import { MantineGrid, MantineGridColumn } from "../../components/mantine/grid";
import { EncodedUrl } from '../../helpers/common';
const DrawingDetail = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { category } = location.state || {};
  const { categoryId } = location.state || {};

  const { siteId } = useParams();
  const [searchValue, setSearchValue] = useState<any>('');
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [selectedImageUrl, setSelectedImageUrl] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { currentPrimaryColor } = useStateContext();
  const { isLargeScreenmin, isSmallScreen } = useCustomMediaQuery();
  const drawings = useSelector((state: any) => state.getsiteData.drawinglist);
  const totalCount = useSelector((state: any) => state.getsiteData.totalCount);
  useEffect(() => {
    dispatch(
      getDrawingBysite({
        siteId,
        categoryId,
        pageNumber,
        pageSize,
        sortColumn: "",
        sortDirection: "",
        searchKeyword: searchValue,
      })
    );
  }, [pageNumber, pageSize, siteId, categoryId,searchValue]);

  const handleDownload = async (url: string) => {
    try {
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement("a");
    const urlObj = new URL(url);
    const fileName = urlObj.searchParams.get("fileName") || "downloaded_file";
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    } catch (error) {
    console.error("Download failed:", error);
    }
    };

  const handleView = async (url: string) => {
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
    const pdfExtension = ".pdf";
    const dwgExtension = ".dwg";
    const wordExtensions = [".doc", ".docx"];
    const excelExtensions = [".xls", ".xlsx"];
    const fileNameMatch = url.match(/fileName=([^&]+)/i);
    const fileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1]) : "";
    const extension = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
    const imagepath = getExtensionFromUrl(url);
    if (imageExtensions.includes(extension)|| imageExtensions.includes(imagepath)) {
      setSelectedImageUrl(url);
      setIsModalOpen(true);
    }
    else if (extension === pdfExtension) {
      handleFilePreview(url);
    }
    else if (wordExtensions.includes(extension) || excelExtensions.includes(extension)) {
      const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`;
      window.open(officeViewerUrl, "_blank");
    }
    else if (extension===dwgExtension) {
      setSelectedImageUrl(url);
      setIsModalOpen(true);
    }
    else {
      window.open(url, "_blank");
    }
  };
  
  const getExtensionFromUrl = (url: string): string => {
    try {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;
      const filename = pathname.split("/").pop() || "";
      return filename.slice(filename.lastIndexOf(".")).toLowerCase();
    } catch (err) {
      console.error("Invalid URL:", url);
      return "";
    }
  };

  const handleFilePreview = async (url: string) => {
    // Open loading window immediately for better UX
    const pdfWindow = window.open("", "_blank");
    if (!pdfWindow) {
        console.error("Failed to open new window");
        return;
    }

    // Create PDF viewer with PDF.js
    pdfWindow.document.write(`
        <!DOCTYPE html>
        <html>
            <head>
                <title>PDF Preview</title>
                <meta charset="UTF-8">
                <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    body {
                        font-family: Arial, sans-serif;
                        background: #525252;
                        overflow: hidden;
                        display: flex;
                        flex-direction: column;
                        height: 100vh;
                    }
                    #toolbar {
                        background: #323639;
                        padding: 10px;
                        display: flex;
                        align-items: center;
                        gap: 15px;
                        color: white;
                        box-shadow: 0 2px 5px rgba(0,0,0,0.3);
                    }
                    #toolbar button {
                        background: #5f6368;
                        color: white;
                        border: none;
                        padding: 8px 15px;
                        cursor: pointer;
                        border-radius: 3px;
                        font-size: 14px;
                        transition: background 0.2s;
                    }
                    #toolbar button:hover {
                        background: #7f8388;
                    }
                    #toolbar button:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                    #pageInfo {
                        color: white;
                        font-size: 14px;
                    }
                    #pageInput {
                        width: 50px;
                        padding: 5px;
                        text-align: center;
                        border: none;
                        border-radius: 3px;
                    }
                    #viewer-container {
                        flex: 1;
                        overflow: auto;
                        display: flex;
                        justify-content: center;
                        padding: 20px;
                    }
                    #pdf-canvas {
                        box-shadow: 0 2px 10px rgba(0,0,0,0.5);
                        background: white;
                    }
                    #loading {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        text-align: center;
                        color: white;
                    }
                    .spinner {
                        border: 4px solid #f3f3f3;
                        border-top: 4px solid #3498db;
                        border-radius: 50%;
                        width: 50px;
                        height: 50px;
                        animation: spin 1s linear infinite;
                        margin: 0 auto 20px;
                    }
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    .hidden {
                        display: none;
                    }
                </style>
            </head>
            <body>
                <div id="toolbar">
                    <button id="prev-page">Previous</button>
                    <button id="next-page">Next</button>
                    <span id="pageInfo">
                        Page <input type="number" id="pageInput" min="1" value="1"> of <span id="page-count">-</span>
                    </span>
                    <button id="zoom-in">Zoom In</button>
                    <button id="zoom-out">Zoom Out</button>
                    <button id="zoom-reset">Reset Zoom</button>
                </div>
                <div id="viewer-container">
                    <div id="loading">
                        <div class="spinner"></div>
                        <div>Loading PDF...</div>
                    </div>
                    <canvas id="pdf-canvas"></canvas>
                </div>

                <script src="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js"></script>
                <script>
                    // Configure PDF.js worker
                    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

                    let pdfDoc = null;
                    let currentPage = 1;
                    let scale = 1.5;
                    const canvas = document.getElementById('pdf-canvas');
                    const ctx = canvas.getContext('2d');
                    const loading = document.getElementById('loading');

                    // Fetch and render PDF
                    async function loadPDF() {
                        try {
                            const response = await fetch('${url}');
                            if (!response.ok) throw new Error('Failed to fetch PDF');

                            const arrayBuffer = await response.arrayBuffer();
                            const loadingTask = pdfjsLib.getDocument({data: arrayBuffer});

                            pdfDoc = await loadingTask.promise;
                            document.getElementById('page-count').textContent = pdfDoc.numPages;

                            loading.classList.add('hidden');
                            renderPage(currentPage);
                        } catch (error) {
                            console.error('Error loading PDF:', error);
                            loading.innerHTML = '<div style="color: #ff6b6b;">Failed to load PDF: ' + error.message + '</div>';
                        }
                    }

                    async function renderPage(num) {
                        try {
                            const page = await pdfDoc.getPage(num);
                            const viewport = page.getViewport({scale: scale});

                            canvas.height = viewport.height;
                            canvas.width = viewport.width;

                            const renderContext = {
                                canvasContext: ctx,
                                viewport: viewport
                            };

                            await page.render(renderContext).promise;

                            currentPage = num;
                            document.getElementById('pageInput').value = num;
                            updateButtons();
                        } catch (error) {
                            console.error('Error rendering page:', error);
                        }
                    }

                    function updateButtons() {
                        document.getElementById('prev-page').disabled = currentPage <= 1;
                        document.getElementById('next-page').disabled = currentPage >= pdfDoc.numPages;
                    }

                    // Event listeners
                    document.getElementById('prev-page').addEventListener('click', () => {
                        if (currentPage > 1) renderPage(currentPage - 1);
                    });

                    document.getElementById('next-page').addEventListener('click', () => {
                        if (currentPage < pdfDoc.numPages) renderPage(currentPage + 1);
                    });

                    document.getElementById('pageInput').addEventListener('change', (e) => {
                        const pageNum = parseInt(e.target.value);
                        if (pageNum >= 1 && pageNum <= pdfDoc.numPages) {
                            renderPage(pageNum);
                        } else {
                            e.target.value = currentPage;
                        }
                    });

                    document.getElementById('zoom-in').addEventListener('click', () => {
                        scale += 0.25;
                        renderPage(currentPage);
                    });

                    document.getElementById('zoom-out').addEventListener('click', () => {
                        if (scale > 0.5) {
                            scale -= 0.25;
                            renderPage(currentPage);
                        }
                    });

                    document.getElementById('zoom-reset').addEventListener('click', () => {
                        scale = 1.5;
                        renderPage(currentPage);
                    });

                    // Keyboard navigation
                    document.addEventListener('keydown', (e) => {
                        if (e.key === 'ArrowLeft' && currentPage > 1) {
                            renderPage(currentPage - 1);
                        } else if (e.key === 'ArrowRight' && currentPage < pdfDoc.numPages) {
                            renderPage(currentPage + 1);
                        }
                    });

                    // Load PDF on page load
                    loadPDF();
                </script>
            </body>
        </html>
    `);
    pdfWindow.document.close();
  };
  
  const handleCloseValue = () => {
    setSearchValue('');
  };

 const classButton = `w-fit text-sm font-thin ${isSmallScreen && 'w-full'}`
  return (
    <Container fluid style={{ width: "100%", padding: "1rem" }}>
      <TitleComponent title={`${category} - Lists`} />
      <Grid mt="lg">
        <div style={{ width: "100%", backgroundColor: "#fff", padding: "1rem 2rem", marginBottom: "1.5rem" }}>
          <MantineGrid className="py-1" grow={true}>
            <MantineGridColumn span={{ base: 12, md: 6, lg: 4 }}>
              <form
                onSubmit={(event: any) => {
                  event.preventDefault();
                  setPageNumber(1);
                }}
              >
                <Flex align="center" gap="sm">
                  <MantineTextInput
                    placeholder="Search by Title"
                    onChange={(event: any) => {
                      setSearchValue(event.currentTarget.value);
                    }}
                    value={searchValue}
                    rightSection={searchValue.length >= 1 && (
                      <MantineCloseButton onClick={handleCloseValue} />
                    )}
                    color={currentPrimaryColor}
                    classNames={{ input: `${PlaceholderUi}` }}
                    style={{ width: '350px' }}
                  />

                  <Button type="submit" color={currentPrimaryColor}
                    className={classButton}

                    onClick={() => setPageNumber(1)} >Search</Button>
                </Flex>
              </form>
            </MantineGridColumn>
          </MantineGrid>
        </div>
        <ScrollArea
          style={{
            width: "100%",
            maxHeight: "70vh",
            overflow: "auto",

            padding: "1rem",
            backgroundColor: "#fff",
          }}
        >
          {drawings?.length > 0 ? (
            <>
              <Table
                striped
                highlightOnHover
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  <tr>
                    {drawingDetailColumns.map((col: any) => (
                      <th
                        key={col.id}
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          fontWeight: "bold",
                          borderBottom: "1px solid #e5e7eb",
                          color: "#333",
                        }}
                      >
                        {col.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody style={{ backgroundColor: "#f8f9fa" }}>
                  {drawings.map(
                    (
                      imageObj: { imageUrl: string | null; uploadFile: string | null; title: string; categoryName: string; clientName: string; siteName: string; },
                      index: number
                    ) => {
                      const fileUrl = imageObj.imageUrl || imageObj.uploadFile || "";
                      let displayText = fileUrl;
                      let encodedUrl = fileUrl;
                      let fileName = "";
                      if (imageObj.uploadFile) {
                        const urlParts =  new URL(imageObj.uploadFile);
                        fileName = urlParts.searchParams.get("fileName") || "";
                        if (fileName && fileName.length > 0) {
                          displayText = fileName;
                          encodedUrl = EncodedUrl(
                            fileName,
                            imageObj.siteName,
                            imageObj.clientName,
                            imageObj.categoryName
                          );
                        }               
                      }               
                      return (
                        <tr
                          key={index}
                          style={{
                            borderBottom: index === drawings.length - 1 ? "none" : "1px solid #e5e7eb",
                          }}
                        >
                          <td style={{ textAlign: "center", padding: "12px" }}>
                            <Text size="sm" style={{ wordBreak: "break-word" }}>
                              {imageObj?.title}
                            </Text>

                          </td>
                          <td style={{ textAlign: "center", padding: "12px" }}>
                            <Text size="sm" style={{ wordBreak: "break-word" }}>
                              {displayText}
                            </Text>
                          </td>
                          <td style={{ textAlign: "center", padding: "12px" }}>
                            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                              <Button variant="light" color="blue" onClick={() => handleView(encodedUrl)}>
                                View
                              </Button>
                              <Button variant="light" color="blue" onClick={() => handleDownload(encodedUrl)}>
                                Download
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>

              </Table>
            </>
          ) : (
            <div style={{ textAlign: "center", marginTop: "1rem" }}>
              <Text color="dimmed">No files available.</Text>
            </div>
          )}
        </ScrollArea>


        {drawings.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
              position: "sticky",
              bottom: 0,
              background: "#fff",
              padding: "10px",
              width: "100%",
            }}
          >
            <MantinePagination
              total={totalCount > 0 ? Math.ceil(totalCount / pageSize) : 1}
              onChange={(value: number) => setPageNumber(value)}
              withEdges
              value={pageNumber}
              size="md"
              color={currentPrimaryColor}
              className="m-auto pb-4"
              valueSelect={pageSize}
              onChangeSelect={(value: string) => {
                setPageSize(Number(value));
                setPageNumber(1);
              }}
            />
          </div>
        )}
      </Grid>


      <Modal
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Drawing Preview"
        size="lg"
      >
        {selectedImageUrl && (
          <Image
            src={selectedImageUrl}
            alt="Drawing Thumbnail"
            width="100%"
            fit="contain"
          />
        )}
      </Modal>
    </Container>
  );
};

export default DrawingDetail;
